/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  SetPreferredTfaMethodErrorResponse,
  SetPreferredTfaMethodRequest,
} from './api.schemas';

import { api } from '../util/http';

export const tfaPreferred = (setPreferredTfaMethodRequest: SetPreferredTfaMethodRequest) => {
  return api<void>({
    url: `/api/auth/tfa/preferred`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setPreferredTfaMethodRequest,
  });
};

export const getTfaPreferredMutationOptions = <
  TError = SetPreferredTfaMethodErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tfaPreferred>>,
    TError,
    { data: SetPreferredTfaMethodRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tfaPreferred>>,
  TError,
  { data: SetPreferredTfaMethodRequest },
  TContext
> => {
  const mutationKey = ['tfaPreferred'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tfaPreferred>>,
    { data: SetPreferredTfaMethodRequest }
  > = (props) => {
    const { data } = props ?? {};

    return tfaPreferred(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TfaPreferredMutationResult = NonNullable<Awaited<ReturnType<typeof tfaPreferred>>>;
export type TfaPreferredMutationBody = SetPreferredTfaMethodRequest;
export type TfaPreferredMutationError = SetPreferredTfaMethodErrorResponse;

export const useTfaPreferred = <TError = SetPreferredTfaMethodErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tfaPreferred>>,
      TError,
      { data: SetPreferredTfaMethodRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tfaPreferred>>,
  TError,
  { data: SetPreferredTfaMethodRequest },
  TContext
> => {
  const mutationOptions = getTfaPreferredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
